var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.2 50.2",
    style: {
      enableBackground: "new 0 0 50.2 50.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xD83D__xDD0D_-System-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_spinner_ios_20_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_xD83C__xDFA8_-Color",
    className: "st0",
    d: "M25.1,4.7c-11.3,0-20.4,9.1-20.4,20.4c0,1.3-1.1,2.4-2.4,2.4S0,26.4,0,25.1 C0,11.2,11.2,0,25.1,0s25.1,11.2,25.1,25.1S39,50.2,25.1,50.2c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4c11.3,0,20.4-9.1,20.4-20.4 C45.5,13.8,36.4,4.7,25.1,4.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.3ca9a45cbf53662bf38443c9184c5210.svg";
export { ForwardRef as ReactComponent };